import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import Overlay from '../../components/Overlay/Overlay';
import Portal from '../../components/Portal/Portal';
import Transition from '../../components/Transition/Transition';
import Position from '../../types/enum/Position';
import Size from '../../types/enum/Size';
import './Sheet.scss';
import ISheetProps from './SheetProps';

const Sheet = ({ isOpen, onClose, size = Size.SMALL, position = Position.LEFT, children, className }: ISheetProps) => {
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      updateFreeze(isOpen);
    }
  }, [isOpen]);

  useEffect(() => {
    return () => {
      updateFreeze(false);
    };
  }, []);

  function updateFreeze(shouldFreeze: boolean) {
    const body = document.querySelector('body');
    if (body) {
      if (shouldFreeze) {
        body.classList.add('sheet-freeze-scroll');
      } else {
        body.classList.remove('sheet-freeze-scroll');
      }
    }
  }

  function handleClose(event: React.MouseEvent) {
    onClose(event);
    updateFreeze(false);
  }

  const classes = classNames(
    {
      sheet: true,
      [`sheet-${size}`]: true,
      [`sheet-${position}`]: true,
    },
    className
  );

  return (
    <Portal>
      <Transition transitionName="sheet-anim" isOpen={isOpen}>
        <div className="sheet-shell">
          <Overlay onClick={handleClose} />
          <div className={classes}>{children}</div>
        </div>
      </Transition>
    </Portal>
  );
};

export default Sheet;
